var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 15,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4557 12.142C25.0652 11.7514 24.432 11.7514 24.0415 12.142L19.7988 16.3846L15.5562 12.142C15.1657 11.7514 14.5325 11.7514 14.142 12.142C13.7514 12.5325 13.7514 13.1657 14.142 13.5562L18.3846 17.7988L14.142 22.0415C13.7514 22.432 13.7514 23.0651 14.142 23.4557C14.5325 23.8462 15.1657 23.8462 15.5562 23.4557L19.7988 19.213L24.0415 23.4557C24.432 23.8462 25.0652 23.8462 25.4557 23.4557C25.8462 23.0651 25.8462 22.432 25.4557 22.0415L21.213 17.7988L25.4557 13.5562C25.8462 13.1657 25.8462 12.5325 25.4557 12.142Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btn-close.f6d0b29ca15620975345a01047254719.svg";
export { ForwardRef as ReactComponent };